import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { v4 as uuidv4 } from "uuid";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";

// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Custom Style
import { transAtthStyle } from "../../../styles/jss/components/transmittal/transAtthStyle";

const useStyles = makeStyles((theme) => transAtthStyle(theme));
const TransmittalHardCopy = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [hardCopyTemplate, setHardCopyTemplate] = useState({
    id: "",
    material: "",
    ref_no: "",
    atthDate: null,
    description: "",
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      files: [],
    },
  });
  const [hardCopyValidationErrors, setHardCopyValidationErrors] = useState({});
  const { submissionValue, setSubmissionValue, setSelectHardCopyDialogOpen } =
    props;

  // Handle Input
  const handleInputChange = (name, validateOnChange) => (event) => {
    setHardCopyTemplate({ ...hardCopyTemplate, [name]: event.target.value });
    if (validateOnChange) {
      hardCopyValidate({ ...hardCopyTemplate, [name]: event.target.value });
    }
  };

  const hardCopyValidate = (fieldValues = hardCopyTemplate) => {
    let temp = { ...hardCopyValidationErrors };
    if ("material" in fieldValues) {
      temp.material = fieldValues.material ? "" : "This field is required";
    }
    setHardCopyValidationErrors({ ...temp });
    if (fieldValues == hardCopyTemplate) {
      return Object.values(temp).every((x) => x == "");
    }
  };

  //Handle Date
  const handleDateFieldChange = (date, name) => {
    const data = { ...hardCopyTemplate };
    data[name] = date;
    setHardCopyTemplate({ ...hardCopyTemplate, ...data });
  };

  const saveHardCopy = () => {
    if (hardCopyValidate()) {
      let data = { ...submissionValue };
      data.documents = Object.assign([], data.documents);
      hardCopyTemplate.id = uuidv4();
      hardCopyTemplate.type = "hardcopy";
      data.documents.push(hardCopyTemplate);
      setSubmissionValue({ ...submissionValue, ...data });
      setSelectHardCopyDialogOpen(false);
      dispatch({
        type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
        data: { ...submissionValue, ...data },
      });
      dispatch({
        type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
        data: { ...hardCopyTemplate, hardCopyTemplate },
      });
    }
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="subtitle1" className={classes.headerText}>
          Input Hard Copy Information
        </Typography>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            required
            fullWidth={true}
            id={"material"}
            name={"material"}
            label={"Submission Material Type"}
            type="text"
            //	required={element.mandatory}
            size="small"
            variant="outlined"
            value={hardCopyTemplate.material || ""}
            onChange={handleInputChange("material")}
            error={
              hardCopyValidationErrors.material &&
              hardCopyValidationErrors.material !== ""
                ? true
                : false
            }
            helperText={hardCopyValidationErrors.material}
          />
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            fullWidth={true}
            id={"ref_no"}
            name={"ref_no"}
            label={"Ref No."}
            type="text"
            size="small"
            variant="outlined"
            value={hardCopyTemplate.ref_no || ""}
            onChange={handleInputChange("ref_no")}
          />
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.textField}
              id={"date"}
              name={"atthDate"}
              label={"Date"}
              format="dd/MM/yyyy"
              placeholder="DD/MM/YYYY"
              size="small"
              fullWidth={true}
              inputVariant="outlined"
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              className={classes.datePickerField}
              value={
                hardCopyTemplate.atthDate != null
                  ? hardCopyTemplate.atthDate
                  : null
              }
              onChange={(date) => handleDateFieldChange(date, "atthDate")}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            fullWidth={true}
            id={"description"}
            name={"description"}
            label={"Description"}
            type="text"
            size="small"
            variant="outlined"
            value={hardCopyTemplate.description || ""}
            onChange={handleInputChange("description")}
          />
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            className={classes.formBtn}
            onClick={saveHardCopy}
          >
            Save and Close
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default TransmittalHardCopy;
